module.exports = __webpack_public_path__ + "assets/logo-clever.png?1b03e8f1dad7d6c4794c889f7e8a6c21"